import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { APP_CONFIG, IAppConfig } from '@app/core/config';
import { UtilsService } from '@app/core/services';
import { IRequestMessageWithdrawCryptoListModel, RequestMessageAdd } from '../models';
import { RequestMessageList } from '../models/request-message-list';
import { SendByType } from '@app/shared/types';
import { IRequestMessageWithdrawCryptoAddModel } from '../models/request-message-withdraw-crypto-add.model';



@Injectable({
	providedIn: 'root'
})
export class RequestMessageService {

	private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

	constructor(
		@Inject(APP_CONFIG) private appConfig: IAppConfig,
		private http: HttpClient,
		private utilsService: UtilsService
	) { }

	getMessages(requestId: string): Observable<RequestMessageList[]> {

		const url = `${this.appConfig.apiEndpoint}/new-core/requests/${requestId}/messages`;

		return this.http.get<RequestMessageList[]>(url, { headers: this.headers })
			.pipe(
				map(response => response['data'] || []),
			);
	}

	addNewMessage(messageAdd: RequestMessageAdd): Observable<HttpEvent<any>> {
		const url = `${this.appConfig.apiEndpoint}/new-core/requests/messages`;
		const formData: FormData = new FormData();
		
		for (const key in messageAdd) {
			if (messageAdd.hasOwnProperty(key)) {
				if(messageAdd[key] !== undefined){
					if (messageAdd[key] instanceof File) {
						formData.append(this.utilsService.upperCaseFirstLetter(key), messageAdd[key], messageAdd[key].name);
					} else {
						formData.append(this.utilsService.upperCaseFirstLetter(key), messageAdd[key]);
					}
				}
			}
		}

		return this.http
			.post(url, formData, {
				reportProgress: true,
				observe: 'events'
			})
			.pipe(map(response => response || {} as HttpEvent<any>));
	}

	downloadDocument(requestId: string, fileDownloadName: string): Observable<any> {
		const url = `${this.appConfig.apiEndpoint}/new-core/requests/${requestId}/messages/attachments/${fileDownloadName}/download`;

		return this.http.get(url, { headers: this.headers, observe: 'response', responseType: 'blob' });
	}


	//#region CRYPTO WITHDRAWAL MESSAGE
	private categorizeMessagesCryptoWithdraw(message: IRequestMessageWithdrawCryptoListModel[]): RequestMessageList[] {
		let messagelist: RequestMessageList[] = [];
		message.forEach(el => {
			let itemMessage: RequestMessageList = {
				requestMessageId: el.id.toString(),
				comment: el.messageContent,
				sendDateUtc: el.createdOnUtc,
				sendBy: el.senderType === 'Expert' ? SendByType.EXPERT : SendByType.CUSTOMER,
				attachment: el.fileUrl === null ? null : {
					displayName: el.fileName,
					downloadName: el.fileName,
					fileUrl: el.fileUrl,
				}
			}
			messagelist.push(itemMessage);
		})
		return messagelist;

	}

	private getFileNameAndExtension(url: string): { fileName: string; extension: string } {
		const fileNameWithExtension = url.split('/').pop() || '';
		const [fileName, extension] = fileNameWithExtension.split('.');
		return { fileName, extension };
	}

	getMessagesCryptoWithdraw(requestId: string): Observable<RequestMessageList[]> {
		const url = `${this.appConfig.apiEndpoint}/crypto-transaction/message/${requestId}/messages`;

		return this.http.get<any[]>(url, { headers: this.headers })
			.pipe(
				map(response => this.categorizeMessagesCryptoWithdraw(response['data'])),
			);
	}


	addNewMessageCryptoWithdraw(messageAdd: IRequestMessageWithdrawCryptoAddModel): Observable<HttpEvent<any>> {
		const url = `${this.appConfig.apiEndpoint}/crypto-transaction/message`;

		return this.http
			.post(url, { data: messageAdd }, {
				reportProgress: true,
				observe: 'events'
			})
			.pipe(map(response => response || {} as HttpEvent<any>));
	}

	uploadFileMessageCryptoWithdraw(value: any): Observable<any> {
		const url = `${this.appConfig.apiEndpoint}/crypto-transaction/message/upload`;
		const formData: FormData = new FormData();
		formData.append('file', value);

		return this.http
			.post(url, formData)
			.pipe(map(response => response));
	}

	//#endregion

}
